import { createActionCreator, paramsEncode, loadScript } from '../../utils/';
import request from '../../utils/request';
import constant from './constant';
import moment from 'moment';
import Urls from 'Urls';
const indexUrl = Urls.PartnerUrl.indexList;
const todyTaskUrl = Urls.TodayTask.todyTaskData;
const getNomalAgentConnUrl = Urls.AgentConnectUrl.getNomalAgentConnInfo;
const getPhoneAgentConnUrl = Urls.AgentConnectUrl.getAgentConnInfo;
const agentMonitorUrl = Urls.TodayTask.agentMonitor;
const taskMonitorUrl = Urls.TodayTask.taskRealTimeMonitor;
const serviceMonitorUrl = Urls.TodayTask.serviceMonitor;
const clearList = Urls.TodayTask.clearList;
const clearOneList = Urls.TodayTask.clearOneList;
const taskExcuteResultUrl = Urls.TodayTask.getIndexTaskList;

export const createLoadingAction = createActionCreator(constant.ListLoading, loading => loading); // 流加载
export const createIndexListAction = createActionCreator(constant.INDEXLIST, list => list); // 通知列表
export const createTodyTaskAction = createActionCreator(constant.TODYTASK, list => list); // 今日任务
export const createNomalAgentConnInfoAction = createActionCreator(constant.NOMALAGENTCONNINFO, list => list); // 连接数统计 
export const createPhoneAgentConnInfoAction = createActionCreator(constant.PHONEAGENTCONNINFO, list => list); // 连接数统计phone
export const createAgentMonitorAction = createActionCreator(constant.AGENT, list => list); // 代理监控
export const createLoadingTaskAction = createActionCreator(constant.TASKLOADING, loading => loading);
export const createTaskMonitorAction = createActionCreator(constant.TASK, list => list); // 实时任务监控
export const createServiceMonitorAction = createActionCreator(constant.SERVICE, list => list); // 服务监控
export const createDiscardMonitorAction = createActionCreator(constant.DISCARD, param => param); // 服务监控
export const createTodyTaskResultAction = createActionCreator(constant.TASKINDEXLIST, list => list); // 今日任务


// 获取废弃监控
// 获取通知列表
export const getDiscardList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createDiscardMonitorAction({isLoading: true}));
            let response = await request(Urls.MonitorUrl.getTop5DiscardTaskCountSuccess);
            let response2 = await request(Urls.MonitorUrl.getTop5DiscardTaskCountThreadHold);
            dispatch(createDiscardMonitorAction({discardList: response, threadList: response2}));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createDiscardMonitorAction({isLoading: false}));
        }
    };
};

// 清空队列
export const clearListAction = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingTaskAction({serveLoading: true}));
            loadScript(clearList);
            let response = await request(serviceMonitorUrl);
            dispatch(createServiceMonitorAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingTaskAction({serveLoading: false}));
        }
    };
};

// 清空队列  -- 单条记录
export const clearOneListAction = (group,queueName) => {
    return async (dispatch, getState) => {
        try {
            console.log("group "+group,"queueName "+queueName);
        
            dispatch(createLoadingTaskAction({serveLoading: true}));
            loadScript(clearOneList + "group="+ group +"&type=" + queueName);
            let response = await request(serviceMonitorUrl);
            dispatch(createServiceMonitorAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingTaskAction({serveLoading: false}));
        }
    };
};

// 获取通知列表
export const getIndexList = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let response = await request(indexUrl);
            dispatch(createIndexListAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};
//获取到达率互动率平均执行时长
export const getTaskExcuteResult = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let response = await request(taskExcuteResultUrl);
            dispatch(createTodyTaskResultAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};
// 获取今日任务数据
export const getTodyTaskData = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingAction(true));
            let response = await request(todyTaskUrl);
            dispatch(createTodyTaskAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingAction(false));
        }
    };
};
//获取连接数统计
export const getNomalAgentConnInfo = () => {
    return async (dispatch, getState) => {
        try {
            //拼接今天日期
            const today = moment().format('YYYY-MM-DD');
            let search = "day="+today;
            let response = await request(getNomalAgentConnUrl+search+"&tencentLimitFlag=Y");
            if(response.connectNumList!=undefined && response.connectNumList!=null){
                dispatch(createNomalAgentConnInfoAction(response.connectNumList));
            }
        } catch (e) {
            throw new Error(e);
        } finally {

        }
    };
};

//获取连接数统计/phone
export const getPhoneAgentConnInfo = () => {
    return async (dispatch, getState) => {
        try {
            //拼接今天日期
            const today = moment().format('YYYY-MM-DD');
            let search = "day="+today;
            let response = await request(getPhoneAgentConnUrl+search);
            if(response!=undefined && response!=null){
              dispatch(createPhoneAgentConnInfoAction(response));
            }
        } catch (e) {
            throw new Error(e);
        } finally {

        }
    };
};

// 获取今日代理监控数据
export const getAgentMonitorData = () => {
    return async (dispatch, getState) => {
        try {
            let response = await request(agentMonitorUrl);
            dispatch(createAgentMonitorAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {

        }
    };
};
// 获取任务实时监控数据
export const getTaskMonitorData = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingTaskAction({loading: true}));
            let response = await request(taskMonitorUrl);
            dispatch(createTaskMonitorAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingTaskAction({loading: false}));
        }
    };
};

// 获取服务实时监控数据
export const getServiceMonitorData = () => {
    return async (dispatch, getState) => {
        try {
            dispatch(createLoadingTaskAction({serveLoading: true}));
            let response = await request(serviceMonitorUrl);
            dispatch(createServiceMonitorAction(response));
        } catch (e) {
            throw new Error(e);
        } finally {
            dispatch(createLoadingTaskAction({serveLoading: false}));
        }
    };
};




// WEBPACK FOOTER //
// ./pages/index/actions.js